import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1161be45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MainIndex" }

import componentMain from "./components/componentMain.vue";
import componentHeade from "./components/componentHeade.vue";
import TabsView from "./components/TabsView.vue";
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'mainIndex',
  setup(__props) {

const width = ref<string>("200px");
const isCollapse = ref<boolean>(false);
const setIsCollapse = (value: boolean) => {
  isCollapse.value = value;
};

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          width: isCollapse.value ? '65px' : '200px'
        }, {
          default: _withCtx(() => [
            _createVNode(componentMain, { isCollapse: isCollapse.value }, null, 8, ["isCollapse"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                _createVNode(componentHeade, {
                  width: width.value,
                  isCollapse: isCollapse.value,
                  onSetIsCollapse: setIsCollapse
                }, null, 8, ["width", "isCollapse"])
              ]),
              _: 1
            }),
            _createVNode(TabsView, { isCollapse: isCollapse.value }, null, 8, ["isCollapse"]),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "never",
                  class: "box-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        (_openBlock(), _createBlock(_KeepAlive, null, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ], 1024))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})